import React from 'react';
import ReactDOM from 'react-dom/client';

import { CssBaseline, ThemeProvider } from '@mui/material';

import App from './App';
import { GlobalProvider } from './Packages/GlobalContext';
import theme from './theme';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalProvider value={undefined}>
        <App />
      </GlobalProvider>
    </ThemeProvider>
  </React.StrictMode>
);
